<script>
import TwContainer from '@/components/generic/tw-container.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'
import { useFundraiserPagePublicStore } from '@/stores/fundraiserPagePublic.js'

export default {
  name: 'FundraiserPageRedirectOldPage',
  components: { TwLoadingSpinner, TwCard, TwContainer },
  props: {
    oldId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      Loading: true,
      NotFound: false,
    }
  },
  mounted() {
    this.redirectToFundraiserPage()
  },
  methods: {
    async redirectToFundraiserPage() {
      try {
        this.ValidationErrorMessage = null
        this.Loading = true
        const fundraiserPage = await useFundraiserPagePublicStore().fetchItemByOldId(this.oldId)
        this.Loading = false
        if(fundraiserPage) {
          this.$router.push({ name: 'FundraiserPagePublicPage', params: { fundraiserPageId: fundraiserPage.id, slug: fundraiserPage.slug } })
        } else {
          this.NotFound = true
        }
      } catch (e) {
        console.error(e)
        this.NotFound = true
        this.Loading = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
}
</script>

<template>
  <tw-container>
    <tw-card class="mt-10">
      <tw-loading-spinner v-if="Loading" />
      <div v-if="NotFound" class="text-center">
        <h1 class="text-2xl font-bold">
          Page not found
        </h1>
      </div>
    </tw-card>
  </tw-container>
</template>

<style scoped>

</style>
